import * as Yup from "yup";

export const COUNTRIES_WITH_MANDATORY_STATES = ["US"];
export const BLACKLISTED_COUNTRIES = ["IR", "KP"];

export const PaypalFormSchema = Yup.object({
  cardholder_name: Yup.string().optional().default(""),
  country: Yup.string().optional().default(""),
  zipcode: Yup.string().optional().default(""),
});

export const CreditCardFormSchema = PaypalFormSchema.concat(
  Yup.object({
    cardholder_name: Yup.string().required("This field cannot be blank."),
    country: Yup.string().required("This field is required."),
    zipcode: Yup.string().when("country", {
      is: (val?: string) => COUNTRIES_WITH_MANDATORY_STATES.includes(val || ""),
      then: () => Yup.string().required("This field is required."),
      otherwise: () => Yup.string().optional().default(""),
    }),
  })
);
